import React from 'react';
import { useTranslation } from 'react-i18next';

import { Step } from './Step';

import pawIcon from '../../assets/home/welcome/paw.svg';
import checkboxIcon from '../../assets/home/checkbox.svg';
import checkmarkIcon from '../../assets/home/checkmark.svg';
import chevronWhiteRight from '../../assets/chevron-white-right.svg';

import { usePetDemographics } from './hooks';

import styles from './WelcomeContent.module.css';

const WelcomeContent = ({ goToNextStep = () => { } }) => {
  const { t } = useTranslation('petDemos');
  const { userName } = usePetDemographics();

  return (
    <>
      <div className={styles.titleSection}>
        <span className={styles.title}>
          {t('welcome.title', { userName })}
        </span>

        <span className={styles.subtitle}>
          {t('welcome.subtitle')}
        </span>
      </div>

      <div className={styles.steps}>
        <Step icon={pawIcon} translationEntry="welcome.steps.addInformation" />

        <Step
          icon={checkboxIcon}
          translationEntry="welcome.steps.confirmPets"
        />

        <Step
          icon={checkmarkIcon}
          translationEntry="welcome.steps.reviewCoverage"
        />
      </div>

      <button
        className={styles.beginButton}
        onClick={goToNextStep}
        type="button"
      >
        {t('welcome.button')}

        <img alt="" src={chevronWhiteRight} />
      </button>
    </>
  );
};

export { WelcomeContent };
